import React from 'react';
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';
import IconRadiusButton from './IconRadiusButton';


export default function ArrowRightButton({ color, ...props }) {
    return (
        <IconRadiusButton {...props}>
            <KeyboardArrowRightIcon style={{ color: color, width: 20, height: 30 }} />
        </IconRadiusButton>
    );
}
